import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
@Pipe({
    name: 'epDate',
    standalone: false
})
export class DatePipe implements PipeTransform {
    public transform(value: string, format: string, convertToLocalTime: boolean = false) {
        if (!value) {
            return value;
        }

        //2014-02-04 or 2014-02-04T12:34:00  <- assumes this format
        let year = value.slice(0, 4);
        let month = value.slice(5, 7);
        let day = value.slice(8, 10);
        let hour = value.slice(11, 13);
        let minute = value.slice(14, 16);
        let second = value.slice(17, 19);

        // Return without transforming if value passed in is not in expected format (yyyy-mm-dd).
        if (isNaN(Number(year)) || isNaN(Number(month)) || isNaN(Number(day))) {
            return value;
        }

        // Convert to local time if requested
        if (convertToLocalTime) {
            if (environment.SaaS) {
                // If the date is in UTC, convert to local time. This is only the case for the SaaS version.
                const dateObj = new Date(Date.UTC(+year, +month - 1, +day, +hour, +minute, +second));
                year = dateObj.getFullYear().toString();
                month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                day = dateObj.getDate().toString().padStart(2, '0');
                hour = dateObj.getHours().toString().padStart(2, '0');
                minute = dateObj.getMinutes().toString().padStart(2, '0');
                second = dateObj.getSeconds().toString().padStart(2, '0');
            }
        }

        let result = '';
        let fmt = format.toString().toLowerCase();

        switch (fmt) {
            case 'mm/dd/yyyy':
                result = month + '/' + day + '/' + year;
                break;
            case 'mm/dd/yy':
                result = month + '/' + day + '/' + year.slice(2, 4);
                break;
            case 'mm/dd/yyyy hh:mm':
                result = month + '/' + day + '/' + year + ' ' + hour + ':' + minute;
                break;
            case 'mm/dd/yyyy hh:mm ampm':
            case 'hh:mm ampm mm/dd/yyyy':
                let hourNum = Number(hour);
                let ampm = 'AM';
                if (hourNum >= 12) {
                    ampm = 'PM';
                }
                let hour12 = hourNum % 12;
                if (hour12 === 0) hour12 = 12;
                if (fmt.slice(-4) == 'ampm') {
                    result = `${month}/${day}/${year} ${hour12}:${minute} ${ampm}`;
                } else {
                    result = `${hour12}:${minute} ${ampm} ${month}/${day}/${year}`;
                }
                break;
            case 'mm/dd/yyyy hh:mm:ss':
                result = month + '/' + day + '/' + year + ' ' + hour + ':' + minute + ':' + second;
                break;
            case 'elapsed':
                // returns xx seconds, xx minutes if over 59 seconds, xx hours if over 59 minutes hours, xx days if over 24 hours
                let now = Date.now();
                let dt = new Date(+year, +month - 1, +day, +hour, +minute, +second);
                let seconds = Math.round((Date.now().valueOf() - dt.valueOf()) / 1000);
                if (seconds < 0) {
                    result = '1 second';
                } else if (seconds <= 59) {
                    result = seconds + ' second';
                } else if (seconds / 60 <= 59) {
                    result = Math.round(seconds / 60) + ' minute';
                } else if (seconds / 3600 <= 23) {
                    result = Math.round(seconds / 3600) + ' hour';
                } else {
                    result = Math.round(seconds / 86400) + ' day';
                }

                //pluralize if number not 1
                if (result.slice(0, 2) != '1 ') {
                    result = result + 's';
                }
                if (result == '1 day') {
                    result = 'yesterday';
                } else {
                    result = result + ' ago';
                }
                break;
            case 'days':
                // days between dates   today,  tomorrow, yesterday, 1 day ago, in 2 days
                let now2 = new Date(Date.now()).setHours(0, 0, 0, 0);
                let dt2 = new Date(+year, +month - 1, +day, 0, 0, 0, 0);
                let days = Math.round((now2.valueOf() - dt2.valueOf()) / (24 * 60 * 60 * 1000));
                if (days == 0) {
                    result = 'today';
                } else if (days == 1) {
                    result = 'yesterday';
                } else if (days == -1) {
                    result = 'tomorrow';
                } else {
                    result = Math.abs(days) + ' days';

                    if (days > 0) {
                        result = result + ' ago';
                    }
                    if (days < 0) {
                        result = 'in ' + result;
                    }
                }
                break;
            default:
                result = 'invalid date format';
        }

        return result;
    }
}
